import React from 'react'
import { Form } from 'stylist'

const RecursiveField = ({ names, children, childArgs }) => {
  if (!names.length) {
    return children(childArgs)
  }
  const [name, ...moreNames] = names
  return (
    <Form.Field
      name={name}
      render={field => (
        <RecursiveField
          names={moreNames}
          children={children}
          childArgs={{ ...childArgs, [name]: field }}
        />
      )}
    />
  )
}

const FormMultiField = ({ names, children }) => (
  <RecursiveField names={names} children={children} childArgs={{}} />
)

export default FormMultiField



// WEBPACK FOOTER //
// ./src/components/FormMultiField.js